import {getRequest, postRequest} from "../fetchWrapper";


/**
 * Upload une image pour la bibliothèque d'images par défaut.
 *
 * @param token Jeton d'authentification.
 * @param body Corps de la requête.
 * @return Response | null Réponse de la requête à l'API.
 */
export const uploadDeceasedDefaultImage = (token, body) => {
    const url = `/api-v1/admin/image/upload`
    return postRequest(url, body, token);
}

/**
 * Liste des images de la bibliothèque d'images par défaut.
 *
 * @param token Jeton d'authentification.
 * @return Response | null Réponse de la requête à l'API.
 */
export const getDefaultImageLibrary = (token) => {
    const url = `/api-v1/admin/image/list`
    return getRequest(url, token);
}

/**
 * Liste des images de la catégorie choisie.
 *
 * @param token Jeton d'authentification.
 * @return Response | null Réponse de la requête à l'API.
 */
export const getSingleCategoryImageList = (token, category) => {
    const url = `/api-v1/admin/library/${category}/list`
    return getRequest(url, token);
}

/**
 * Lecture d'une image de la bibliothèque d'images par défaut.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant de l'image.
 */
export const getSingleImage = (token, id) => {
    const url = `/api-v1/admin/image/${id}`
    return getRequest(url, token);
}

/**
 * Suppression d'une image de la bibliothèque d'images par défaut.
 *
 * @param token Jeton d'authentification.
 * @param body Corps de la requête.
 * @return Response | null Réponse de la requête à l'API.
 */
export const deleteSingleImageFromDb = (token, body) => {
    const url = `/api-v1/admin/image/delete`
    return postRequest(url, body, token);
}

/**
 * Modification de la visibilité d'une image de la bibliothèque d'images par défaut.
 *
 * @param token Jeton d'authentification.
 * @param body Corps de la requête.
 * @return Response | null Réponse de la requête à l'API.
 */
export const setImageEnable = (token, body) => {
    const url = `/api-v1/admin/image/enable`
    return postRequest(url, body, token);
}